import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"label":"Team","outlined":""},model:{value:(_vm.team),callback:function ($$v) {_vm.team=$$v},expression:"team"}})}
var staticRenderFns = []

export { render, staticRenderFns }